export default __webpack_public_path__ + "static/media/IMG_9771.f8778529.JPG";